const ACCORDION_INITIALIZED = 'accordion--initialized';
const ACCORDION_HIDDEN_CLASS = 'accordion__body--hidden';
const ACCORDION_ICON = '.accordion__icon use';

export default class Accordion {
    constructor(accordion, opts = {}) {
        this.opts = {
            // 'closed' (default), 'open-all', or 'responsive'
            initialState: 'closed',
            // used only when initialState === 'responsive'
            breakpoint: 1280,
            // allow data-* on the element to override
            ...opts,
            ...Accordion.readDatasetOptions(accordion),
        };

        this.accordionEl = accordion;
        this.accordionLabels = accordion.querySelectorAll('.accordion__label');
        this.accordionBodies = accordion.querySelectorAll('.accordion__body');

        this.init(accordion);
        this.bind();
    }

    static readDatasetOptions(el) {
        const out = {};
        // 'closed'|'open-all'|'responsive'
        if (el.dataset.accordionInitial) {out.initialState = el.dataset.accordionInitial;}
        if (el.dataset.accordionBreakpoint) {out.breakpoint = Number(el.dataset.accordionBreakpoint);}
        return out;
    }

    static getBody( label ) {
        return document.getElementById( label.getAttribute( 'aria-controls' ) );
    }

    init( accordion ) {
        // collapse the expanded no-JS state
        for ( const label of this.accordionLabels ) {
            label.querySelector( ACCORDION_ICON ).setAttribute( 'href', '#plus' );
            label.setAttribute( 'aria-expanded', 'false' );
        }

        // hide all bodies
        for ( const body of this.accordionBodies ) {
            body.classList.add( ACCORDION_HIDDEN_CLASS );
        }

        // apply instance-specific initial state
        const { initialState, breakpoint } = this.opts;
        if (initialState === 'open-all') {
            this.openAll();
        }
        else if (initialState === 'responsive') {
            const isMobile = window.matchMedia(
                `(max-width: ${breakpoint - 1}px)`
            ).matches;
            if (!isMobile) {
                this.openAll();
            }
            // (optional) live-resize only for this instance:
            const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
            mq.addEventListener?.('change', (e) => {
                if (e.matches) {
                    this.closeAll();
                }
        else {
                    this.openAll();
                }
            });
        }

        // see css ( prevent open accordion bodies )
        accordion.classList.add( ACCORDION_INITIALIZED );
    }

    openAll() {
        for (const label of this.accordionLabels) {
            const body = Accordion.getBody(label);
            body.classList.remove(ACCORDION_HIDDEN_CLASS);
            label.setAttribute('aria-expanded', 'true');
            label.querySelector(ACCORDION_ICON).setAttribute('href', '#minus');
        }
    }

    closeAll() {
        for (const label of this.accordionLabels) {
            const body = Accordion.getBody(label);
            body.classList.add(ACCORDION_HIDDEN_CLASS);
            label.setAttribute('aria-expanded', 'false');
            label.querySelector(ACCORDION_ICON).setAttribute('href', '#plus');
        }
    }

    bind() {
        // bind events
        for ( const label of this.accordionLabels ) {

            label.addEventListener( 'click', ( e ) => {
                this.toggleBody( e.currentTarget );
            } );

            label.addEventListener( 'keydown', ( e ) => {
                this.detectKeys( e );
            } );
        }
    }

    toggleBody( label ) {
        const body = Accordion.getBody( label ),
            isHidden = body.classList.contains( ACCORDION_HIDDEN_CLASS );

        this.selectLabel( label );

        if ( isHidden ) {
            // open body
            body.classList.remove( ACCORDION_HIDDEN_CLASS );
            label.querySelector( ACCORDION_ICON ).setAttribute( 'href', '#minus' );
            label.setAttribute( 'aria-expanded', 'true' );
        }
        else {
            // close body
            body.classList.add( ACCORDION_HIDDEN_CLASS );
            label.querySelector( ACCORDION_ICON ).setAttribute( 'href', '#plus' );
            label.setAttribute( 'aria-expanded', 'false' );
        }
    }

    selectLabel( label ) {
        label.focus();
    }

    selectFirstLabel( e ) {
        e.stopPropagation();
        e.preventDefault();
        this.selectLabel( this.accordionLabels.item( 0 ) );
    }

    selectLastLabel( e ) {
        e.stopPropagation();
        e.preventDefault();

        let index = this.accordionLabels.length - 1;
        this.selectLabel( this.accordionLabels.item( index ) );
    }

    selectNextLabel( e ) {
        e.stopPropagation();
        e.preventDefault();

        let index = Array.prototype.indexOf.call( this.accordionLabels, e.currentTarget );

        if ( index < this.accordionLabels.length - 1 ) {
            index += 1;
        }
        else {
            index = 0;
        }

        this.selectLabel( this.accordionLabels.item( index ) );
    }

    selectPreviousLabel( e ) {
        e.stopPropagation();
        e.preventDefault();

        let index = Array.prototype.indexOf.call( this.accordionLabels, e.currentTarget );

        if ( index > 0 ) {
            index -= 1;
        }
        else {
            index = this.accordionLabels.length - 1;
        }

        this.selectLabel( this.accordionLabels.item( index ) );
    }

    detectKeys( e ) {
        switch ( e.key ) {
            case 'End': {
                this.selectLastLabel( e );
                break;
            }
            case 'Home': {
                this.selectFirstLabel( e );
                break;
            }
            case 'ArrowLeft':
            case 'ArrowUp': {
                this.selectPreviousLabel( e );
                break;
            }
            case 'ArrowRight':
            case 'ArrowDown': {
                this.selectNextLabel( e );
                break;
            }
        }
    }

}
